module.exports = __webpack_public_path__ + "static/gallery13-84d03b092969846868ff7f6412a9560a.png";